import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaTools,
  FaShoppingCart,
  FaRocket,
  FaShieldAlt,
  FaMobileAlt,
  FaStar,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const UserFriendlyEcommerceWebsitesInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="User-friendly E-commerce Websites in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Seamless Shopping Experience</Subheading>}
        heading={
          <Heading>
            User-friendly <span tw="text-primary-500">E-commerce Websites</span>{" "}
            in Al Barsha
          </Heading>
        }
        description={
          <Description>
            MilaajBrandset crafts user-friendly e-commerce websites in **Al
            Barsha**, designed for intuitive navigation and seamless shopping to
            boost customer satisfaction and sales.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1616469829581-73993eb86b02?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1522542550221-31fd19575a2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Enhance Your Store"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Usability Matters</Subheading>}
        heading="Intuitive E-commerce Solutions"
        description="Our user-friendly stores drive engagement and loyalty."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Easy Navigation",
            description: "Clear menus and quick access.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Checkout",
            description: "Streamlined purchase process.",
          },
          {
            icon: <FaTools color="#ff5464" size={40} />,
            title: "Custom UX Design",
            description: "Tailored to your audience.",
          },
          {
            icon: <FaShieldAlt color="#ff5464" size={40} />,
            title: "Secure & Simple",
            description: "Safe without complexity.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Mobile-Optimized",
            description: "Flawless on any device.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Al Barsha Leaders",
            description: "Trusted local UX experts.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Design</Subheading>}
        heading="Our User-friendly Development Process"
        description={
          <Description>
            We create intuitive e-commerce stores with care:
            <ul tw="mt-4 list-disc pl-6">
              <li>Research: Understand your customers’ needs.</li>
              <li>Design: Build clear, engaging interfaces.</li>
              <li>Development: Code for simplicity and speed.</li>
              <li>Testing: Validate ease of use across devices.</li>
              <li>Launch: Deliver a polished, user-centric store.</li>
              <li>Support: Optimize based on user feedback.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1661956602116-aa6865609028?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2564&q=80", // E-commerce success imagery
          "https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1531973576160-7125cd663d86?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team working
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Our Achievements</Subheading>}
        heading="User-friendly Success in Al Barsha"
        description="Our intuitive stores deliver results."
        cards={[
          {
            icon: <FaShoppingCart color="#ff5464" size={40} />,
            title: "Engagement Boost",
            description: "30% higher time on site.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Conversion Gains",
            description: "25% more completed purchases.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "93% positive feedback.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready for Simplicity?</Subheading>}
        heading="User-friendly E-commerce Websites in Al Barsha"
        description={
          <Description>
            MilaajBrandset builds user-friendly e-commerce websites in Al Barsha
            to delight customers and drive sales. Contact us to create your
            intuitive store today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1559526324-4b87b5e36e44?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Team celebrating
          "https://images.unsplash.com/photo-1621274147744-cfb5032c9d77?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // Mobile e-commerce visuals
          "https://images.unsplash.com/photo-1633876841157-78c12e53f35a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2340&q=80", // E-commerce success imagery
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
